import { render, staticRenderFns } from "./AutoCompleteSearchBar.vue?vue&type=template&id=5612f9c2"
import script from "./AutoCompleteSearchBar.vue?vue&type=script&lang=js"
export * from "./AutoCompleteSearchBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports